const RATINGS_LANG = {
  en: {
    A: 'Above average',
    B: 'Average',
    C: 'Below average',
    D: 'No other organization',
  },
  fr: {
    A: 'Exceptionnel',
    B: 'Bon',
    C: 'Domaine à améliorer',
    D: 'Aucune autre organisation',
  },
};

export { RATINGS_LANG };
